module.exports = __webpack_public_path__ + "static/media/exportXLSXIcon.7848d2c1.svg";